import React from "react";
import { Routes, Route } from "react-router-dom";
import SportsNavBar from "../../components/common/SportsNavBar";

import Cricket from "./Cricket";
import NBA from "./NBA";
import NFL from "./NFL";
import Soccer from "./Soccer";
import Golf from "./Golf";
import MLB from "./MLB";
import Tennis from "./Tennis";
import Hockey from "./Hockey";
import NHL from "./NHL";
import Chess from "./Chess";
import { Helmet } from "react-helmet";
import Olympics from "./Olympics";

function Sports() {
  return (
    <div>
      <Helmet>
        <title>BharatAbroad Sports – Celebrating Indian Heritage</title>
        <meta
          name="description"
          content="Stay updated with sports news, events, and achievements of Indians/Bharatians across the globe. Celebrating the spirit of sportsmanship and unity."
        />
        <meta
          name="keywords"
          content="Bharat Abroad sports, Indian sports news, global sports news, cricket updates, IPL, international cricket, NFL, NBA, basketball, golf tournaments, tennis, soccer, football, sports events, Indian athletes abroad, sports community, global sports fans"
        />
        <meta
          name="keywords"
          content="BharatAbroad,Bharat Abroad,abroad,bharat,Bharatian Global Community,Community Portal,Global Indians,Indian Events,Global Bharatian,Sports,Health,Travel,Indian Movies,News,Cultural Exchange,Indian Heritage,Global Networking,Indian Communities Abroad,Cultural Events,International News,Indian Culture,Indian Lifestyle,Travel Destinations,Health Tips,Sports Events,Movie Reviews,Indian Cinema,Travel Guides,Health Awareness,Community Engagement,Global Events,Indian Traditions,Cultural Heritage,Indian Cuisine,Festivals,Travel Experiences,Health Insights,Sports Highlights,Movie Recommendations,Community Stories,Indian Art,Indian Music,Indian Dance,Indian Literature,Indian Fashion,Indian History,Indian Architecture,Indian Philosophy,Indian Spirituality,Indian Languages,Indian Cuisine Recipes,Indian Festivals Calendar,Indian Cultural Events,Indian Cultural Organizations,Indian Cultural Institutions "
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Celebrating Indian Sports Heritage - BharatAbroad"
        />
        <meta
          property="og:description"
          content=" BharatAbroad is a global community platform dedicated to connecting Bharatians/Indians living overseas with the rich culture, heritage, and spirit of Bharat. It serves as a space for sharing local community events, stories, cultural insights, and experiences of life abroad. The YouTube channel offers Bharat’s/India’s vibrant traditions, Heritage through videos on local events, festivals, temples, local cuisine, Tourist places, Market places, and cultural practices. "
        />
        <meta property="og:url" content="https://www.bharatabroad.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0060.jpg"
        />
        <meta property="og:site_name" content="BharatAbroad " />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <Routes>
        {/* Main sports page shows maintenance
        <Route
          index
          element={
            <div
              style={{
                padding: "40px",
                textAlign: "center",
                minHeight: "70vh",
              }}
            >
              <h1>Sports Section Under Maintenance</h1>
              <p>
                We are working hard to bring you the latest sports updates.
                Please check back later!
              </p>
            </div>
          }
        /> */}
        {/* Individual sports pages */}
        <Route path="" element={<Cricket />} />
        <Route path="cricket" element={<Cricket />} />
        <Route path="nba" element={<NBA />} />
        <Route path="nfl" element={<NFL />} />
        <Route path="soccer" element={<Soccer />} />
        <Route path="golf" element={<Golf />} />
        <Route path="mlb" element={<MLB />} />
        <Route path="tennis" element={<Tennis />} />
        <Route path="hockey" element={<Hockey />} />
        <Route path="nhl" element={<NHL />} />
        <Route path="chess" element={<Chess />} />
        <Route path="olympics" element={<Olympics />} />
      </Routes>
    </div>
  );
}

export default Sports;
